module.exports = __webpack_public_path__ + "img/affiliate-programme.19391ab8.svg";